import { css } from '@linaria/core'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Spinner } from '#components/Spinner'

const loadingClass = css`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`
export const FullscreenLoading: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={loadingClass}>
      <Spinner size="xl" subtitle={t('app.loading', 'Loading MAN Intelligent Configurator…')} />
    </div>
  )
}
